import { styled } from '@mui/system';
import { Form } from 'formik';

export const Actions = styled('div')({
	marginTop: '16px',
});

export const FormWrap = styled(Form, {
	shouldForwardProp: (prop) => prop !== 'isDefaultGapEnabled' && prop !== 'isMaxWidthEnabled',
})(
	({
		isDefaultGapEnabled,
		isMaxWidthEnabled,
	}: {
		isDefaultGapEnabled: boolean;
		isMaxWidthEnabled: boolean;
	}) => ({
		display: 'flex',
		flexDirection: 'column',
		...(isDefaultGapEnabled && { gap: '16px' }),
		...(isMaxWidthEnabled && { maxWidth: '730px' }),

		'.ck-content': {
			img: {
				maxWidth: '100% !important',
				height: 'auto',
			},
		},
	}),
);
